// Base Client
import { RpcError } from "grpc-web";
import { getApiToken } from "../helpers";
import { getBffRequest } from "./base/api";

// Protos
import { ClaimsBFFControllerClient } from "./protos/Claims-bffServiceClientPb";
import {
	ProvidersGetNotificationPreferencesRequest,
	ProvidersGetNotificationPreferencesResponse,
	ProvidersGetRequest,
	ProvidersGetResponse,
	ProvidersSearchRequest,
	ProvidersSearchResponse,
	ProvidersUpdateNotificationPreferencesRequest,
	GetProviderRatesRequest,
	GetProviderRatesResponse,
	DeleteProviderRateRequest,
	DeleteProviderRateResponse,
	UpsertProviderRateRequest,
	UpsertProviderRateResponse
} from "./protos/messages/providers.message_pb";

export const getProvider = async (attyId: number): Promise<ProvidersGetResponse> => {
	const token: string = getApiToken();

	const request: ProvidersGetRequest = new ProvidersGetRequest();
	request.setAttyid(attyId);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.getProvider(request, {})
		.then((response: ProvidersGetResponse) => response)
		.catch((err: RpcError) => {
			console.error(err);
			throw err;
		});
};

export const searchProviders = async (term: string): Promise<ProvidersSearchResponse> => {
	const token: string = getApiToken();

	const request: ProvidersSearchRequest = new ProvidersSearchRequest();
	request.setTerm(term);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.searchProviders(request, {})
		.then((response: ProvidersSearchResponse) => response)
		.catch((err) => {
			console.error(err);
			throw err;
		});
};

export const getProviderNotificationPreferences = async (
	attyId: number
): Promise<ProvidersGetNotificationPreferencesResponse> => {
	const token: string = getApiToken();

	const request: ProvidersGetNotificationPreferencesRequest = new ProvidersGetNotificationPreferencesRequest();
	request.setId(attyId);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.getProviderNotificationPreferencesByUserId(request, {})
		.then((response: ProvidersGetNotificationPreferencesResponse) => response)
		.catch((err) => {
			console.error(err);
			throw err;
		});
};

export const updateProviderNotificationPreferences = async (
	attyId: number,
	onApproved: boolean,
	onInReview: boolean,
	onQueued: boolean,
	onClosedPaid: boolean
): Promise<ProvidersGetNotificationPreferencesResponse> => {
	const token: string = getApiToken();

	const request: ProvidersUpdateNotificationPreferencesRequest = new ProvidersUpdateNotificationPreferencesRequest();
	request.setId(attyId);
	request.setOnApproved(onApproved);
	request.setOnInReview(onInReview);
	request.setOnQueued(onQueued);
	request.setOnClosedPaid(onClosedPaid);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.updateProviderNotificationPreferencesByUserId(request, {})
		.then((response: ProvidersGetNotificationPreferencesResponse) => response)
		.catch((err) => {
			console.error(err);
			throw err;
		});
};

export const getProviderRates = async (attyId: string): Promise<GetProviderRatesResponse> => {
	const token: string = getApiToken();

	const request: GetProviderRatesRequest = new GetProviderRatesRequest();
	request.setAttyId(attyId);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.getProviderRates(request, {})
		.then((response: GetProviderRatesResponse) => response)
		.catch((err: RpcError) => {
			console.error(err);
			throw err;
		});
};

export const deleteProviderRate = async (id: number): Promise<DeleteProviderRateResponse> => {
	const token: string = getApiToken();

	const request: DeleteProviderRateRequest = new DeleteProviderRateRequest();
	request.setId(id);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.deleteProviderRate(request, {})
		.then((response: DeleteProviderRateResponse) => response)
		.catch((err: RpcError) => {
			console.error(err);
			throw err;
		});
};

export const upsertProviderRate = async (
	attyId: string,
	benefitCode: string,
	standardHourlyRate?: string,
	standardFlatRate?: string
): Promise<UpsertProviderRateResponse> => {
	const token: string = getApiToken();

	const request: UpsertProviderRateRequest = new UpsertProviderRateRequest();
	request.setAttyId(attyId);
	request.setBenefitCode(benefitCode);
	if (standardHourlyRate) {
		request.setStandardHourlyRate(standardHourlyRate);
	}
	if (standardFlatRate) {
		request.setStandardFlatRate(standardFlatRate);
	}

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.upsertProviderRate(request, {})
		.then((response: UpsertProviderRateResponse) => response)
		.catch((err: RpcError) => {
			console.error(err);
			throw err;
		});
};
